export default __webpack_public_path__ + "static/media/021-sunset.c49f5d96.svg";